import { createContext } from "react";

export const RegisterContext = createContext({
  activeStep: 0,
  setActiveStep: () => {},
  mobileNumber: "",
  setMobileNumber: () => {},
  aadharNumber: "",
  setAadharNumber: () => {},
  userToken: "",
  setUserToken: () => {},
});

export const ForgotPasswordContext = createContext();

export const ToastContext = createContext({
  showToast: () => {},
});
